import React from "react";
import Information from "./sub-components/Information";
import Documents from "./sub-components/Documents";
import Validation from "./sub-components/Validation";

function Borrower({ data, reGetData }) {
  return (
    <div>
      <h3 class="w-11/12 mx-auto my-4 text-lg font-medium leading-none text-gray-900 dark:text-white">
        اطلاعات وام گیرنده - {data?.user?.name || ""}
      </h3>

      <Information data={data}  reGetData={reGetData} />
      <Validation data={data}  reGetData={reGetData}/>
      <Documents data={data} reGetData={reGetData} />
    </div>
  );
}

export default Borrower;
